import { Component, Input, inject } from '@angular/core';
import {UserService} from '../../../../core/services/user/user.service';
import {GoogleTagManagerService} from '../../../../core/services/google-tag-manager.service';
import {BreakpointsDetectorService} from '../../../services/breakpoints-detector.service';
import {ModalService} from '../../../modal-v2/modal.service';
import {of} from 'rxjs';
import {filter, map, switchMap, tap} from 'rxjs/operators';
import {StaticContentService} from '../../../services/static-content.service';
import {CommonModule} from '@angular/common';
import {TimerComponent} from '../timer/timer.component';
import {RouterModule} from '@angular/router';
import {TournamentStrategies} from '../../../../page/tournaments/tournaments.service';
import {ArabicService} from '../../../services/arabic.service';
import { TranslatePipe } from '../../translation/translate.pipe';
import { GamePreviewComponent } from '../../layout/game-preview/game-preview.component';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
    selector: 'app-tournament-preview',
    templateUrl: './tournament-preview.component.html',
    styleUrls: ['./tournament-preview.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        TimerComponent,
        TranslatePipe,
        GamePreviewComponent,
        SafePipe,
    ]
})
export class TournamentPreviewComponent {
  user = inject(UserService);
  breakpoints = inject(BreakpointsDetectorService);
  rtl = inject(ArabicService);
  private _gtm = inject(GoogleTagManagerService);
  private _modal = inject(ModalService);
  private _static = inject(StaticContentService);


  @Input() tournament: any;

  public tournamentStrategyWin: TournamentStrategies = TournamentStrategies.WIN;
  public tournamentStrategyBet: TournamentStrategies = TournamentStrategies.BET;

  onGetBonusClick() {
    this._gtm.getBonusTournamentClick('get_bonus_tournament', 'tournament');
  }

  async showModal(tournament: any ) {
    of(tournament).pipe(
      switchMap(() => {
        return tournament.isGroupTournament ?
          this._static.item({slug: 'details-group-tournaments'}) :
          of([{Title: tournament?.Title, Content: tournament?.Content}]);
      }),
      filter(data => Boolean(data?.length)),
      map(data => data[0]),
      tap(async (data) => {
        const component = await import('../../../../core/modal-v2/components/lazy/details-modal/details-modal.component');
        await this._modal.openLazy(component?.DetailsModalComponent, {
          template: 'CLEAR',
          data: {
            Title: data?.Title,
            Text: data?.Content
          }
        });
      })
    ).subscribe();

  }
}
